// React import
import React from 'react';
import { connect } from "react-redux";
// Components import
import TokenAnalyzerStatItem from "../TokenAnalyzerStatItem";
// Styles imports
import './TokenAnalyzerStat.css';
import '../../util.css'

class TokenAnalyzerStat extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {

        const { tokenStats } = this.props.tokenAnalyzer;
        const { ai_level } = this.props.userData;

        return (
            <div className={"token-analyzer__stats-block noselect"}>
                {tokenStats.map(tokenStat =>
                    <TokenAnalyzerStatItem
                        key={tokenStat.type}
                        type={tokenStat.type}
                        indicator={tokenStat.indicator}
                        stat={tokenStat.stat}
                        firstDescription={tokenStat.firstDescription}
                        secondDescription={tokenStat.secondDescription}
                        aiLevel={ ai_level }
                    />
                )}
            </div>
        );
    }

}

const mapStateToProps = ({ tokenAnalyzer, userData }) => {
    return { tokenAnalyzer, userData };
};

export default connect(mapStateToProps)(TokenAnalyzerStat);
